class PredictiveSearch extends HTMLElement {
  // constructor() {
  //   super();
  //   this.input = this.querySelector('input[type="text"]');
  //   this.predictiveSearchResults = document.querySelector('#predictive-search');
  //   this.input.addEventListener('input', this.debounce((event) => {
  //     this.onChange(event);
  //     var input_length = this.input.value.length;
  //     if(input_length>0){
  //       document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
  //         SeachButtons.disabled = false;
  //       });
  //     }else{
  //       document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
  //         SeachButtons.disabled = true;
  //       });
  //     } 
  //   }, 300).bind(this));
  // }
  // onChange() {
  //   const searchTerm = this.input.value.trim();
  //   if (!searchTerm.length) {
  //     this.close();
  //     return;
  //   }
  //   this.getSearchResults(searchTerm);
  // }
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.predictiveSearchResults = document.querySelector('#predictive-search');

    if (this.input) {
      this.input.addEventListener('input', this.debounce((event) => {
        this.onChange(event);
        var input_length = this.input.value.length;
        if(input_length>0){
          document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
            SeachButtons.disabled = false;
          });
        }else{
          document.querySelectorAll('.search-Button').forEach(function(SeachButtons){
            SeachButtons.disabled = true;
          });
        }
      }, 300).bind(this));
    }
  }
  onChange() {
    if (this.input) {
        const searchTerm = this.input.value.trim();
        if (!searchTerm.length) {
          this.close();
          return;
        }
        this.getSearchResults(searchTerm);
    }
  }
  
getSearchResults(searchTerm) {
  fetch(`/search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=10&section_id=predictive-search`)
    .then((response) => {
      if (!response.ok) {
        this.close();
        throw new Error(response.status);
      }
      return response.text();
    })
    .then((text) => {
      const parsedHTML = new DOMParser().parseFromString(text, 'text/html');
      const resultsSection = parsedHTML.querySelector('#shopify-section-predictive-search');
      
      const noResultTextEl = document.querySelector('.no-result-text');
      const topResultNoSearch = document.querySelector('.top-result.no-search');
      const searchRowNoSearch = document.querySelector('.search-row.no-search');

      this.updateSuggestions(resultsSection, searchTerm);
      
      let hasResults = false;
      
      if (resultsSection) {
        const textContent = resultsSection.textContent.trim();
        
        const productResults = resultsSection.querySelectorAll('.search-row:not(.no-search)');
        const highlightsContent = resultsSection.querySelector('.highlights');
        
        let hasValidHighlights = false;
        if (highlightsContent) {
          const productCards = highlightsContent.querySelectorAll('[data-product-id], .product-card, .product-item');
          const productImages = highlightsContent.querySelectorAll('img[src*="product"]');
          const productTitles = highlightsContent.querySelectorAll('h3, h4, .product-title');
          
          hasValidHighlights = productCards.length > 0 || 
                              productImages.length > 0 || 
                              productTitles.length > 0;
          
          console.log("Product cards:", productCards.length);
          console.log("Product images:", productImages.length); 
          console.log("Product titles:", productTitles.length);
        }
        
        hasResults = (productResults.length > 0) || hasValidHighlights;
        
        if (hasResults && textContent.length < 50) {
          hasResults = false;
        }
        
      }
      
      if (!hasResults) {
        
        if (noResultTextEl) {
          noResultTextEl.innerHTML = `No results match your search for <span class="search-term">"${searchTerm}"</span>. You might be interested in these...`;
          noResultTextEl.style.display = 'block';
        }
        if (topResultNoSearch) {
          topResultNoSearch.style.display = 'block';
        }
        if (searchRowNoSearch) {
          searchRowNoSearch.style.display = 'flex';
        }
        
        if (this.predictiveSearchResults) {
          this.predictiveSearchResults.innerHTML = '';
          this.predictiveSearchResults.style.display = 'none';
        }
        
        const predictiveSearchContainer = document.getElementById('predictive-search');
        if (predictiveSearchContainer) {
          predictiveSearchContainer.style.display = 'none';
        }
      } else {
        
        if (this.predictiveSearchResults && resultsSection) {
          this.predictiveSearchResults.innerHTML = resultsSection.innerHTML;
          this.predictiveSearchResults.style.display = 'block';
        }
        
        const predictiveSearchContainer = document.getElementById('predictive-search');
        if (predictiveSearchContainer) {
          predictiveSearchContainer.style.display = 'block';
        }
        if (noResultTextEl) noResultTextEl.style.display = 'none';
        if (topResultNoSearch) topResultNoSearch.style.display = 'none';
        if (searchRowNoSearch) searchRowNoSearch.style.display = 'none';
        
        if (typeof quickAddButton === 'function') quickAddButton();
      }
      
      const searchInput = document.getElementById('SearchValue');
      if (searchInput) searchInput.value = searchTerm;
      this.open();
    })
    .catch((error) => {
      console.error("Search error:", error);
      this.close();
      throw error;
    });
}



updateSuggestions(resultsSection, searchTerm) {
  const suggestionsContainer = document.querySelector('.left ul');
  if (!suggestionsContainer) return;

  let suggestions = [];

  if (resultsSection) {
    const links = resultsSection.querySelectorAll(
      'a[href*="/products/"], a[href*="/collections/"], a[href*="/pages/"]'
    );

    links.forEach((link) => {
      // Get text/title
      const titleEl = link.querySelector('h3, h4, .product-title, [data-product-title]');
      let title = titleEl ? titleEl.textContent.trim() : link.textContent.trim();
      const href = link.getAttribute('href');

      // 🚫 Skip "View Product" links (button-style)
      if (/view product/i.test(title)) return;

      if (title && href && title.length <= 60) {
        suggestions.push({ text: title, href });
      }
    });

    // Deduplicate by href
    const uniqueMap = new Map();
    suggestions.forEach(item => {
      if (!uniqueMap.has(item.href)) uniqueMap.set(item.href, item);
    });
    suggestions = Array.from(uniqueMap.values());

    // Limit to 4
    suggestions = suggestions.slice(0, 4);
  }

  // Fallbacks if no results
  if (suggestions.length === 0) {
    const baseTerms = searchTerm.toLowerCase().split(' ');
    const fallbackSuggestions = [
      `${searchTerm} Collection`,
      `${baseTerms[0]} Products`,
      `${baseTerms[0]} Set`,
      `${baseTerms[0]} Bundle`
    ];
    suggestions = fallbackSuggestions.map(term => ({
      text: term,
      href: `/search?q=${encodeURIComponent(term)}`
    }));
  }

  // Render
  suggestionsContainer.innerHTML = suggestions
    .map(s => `<li><a href="${s.href}">${s.text}</a></li>`)
    .join('');

  console.log("✅ Updated unique + filtered suggestions:", suggestions);
}

// updateSuggestions(resultsSection, searchTerm) {
//   const suggestionsContainer = document.querySelector('.left ul');
//   if (!suggestionsContainer) return;

//   let suggestions = [];

//   if (resultsSection) {
   
//     const links = resultsSection.querySelectorAll(
//       'a[href*="/products/"], a[href*="/collections/"], a[href*="/pages/"]'
//     );

//     links.forEach((link) => {
     
//       const titleEl = link.querySelector('h3, h4, .product-title, [data-product-title]');
//       const title = titleEl ? titleEl.textContent.trim() : link.textContent.trim();
//       const href = link.getAttribute('href');

     
//       if (title && href && title.length <= 60) {
//         suggestions.push({ text: title, href: href });
//       }
//     });

   
//     suggestions = suggestions.slice(0, 4);
//   }

 
//   if (suggestions.length === 0) {
//     const baseTerms = searchTerm.toLowerCase().split(' ');
//     const fallbackSuggestions = [
//       `${searchTerm} Collection`,
//       `${baseTerms[0]} Products`,
//       `${baseTerms[0]} Set`,
//       `${baseTerms[0]} Bundle`
//     ];
//     suggestions = fallbackSuggestions.map(term => ({
//       text: term,
//       href: `/search?q=${encodeURIComponent(term)}`
//     }));
//   }

 
//   suggestionsContainer.innerHTML = suggestions.map(s => 
//     `<li><a href="${s.href}">${s.text}</a></li>`
//   ).join('');

//   console.log("Updated suggestions:", suggestions);
// }

 
  
  open() {
    this.predictiveSearchResults.style.display = 'block';
    initSearchRowSwipers();
    const searchInput = document.querySelector('predictive-search .search-input');
    const noSearchResult = document.querySelector('.no-result-text');
    const searchRowNoSearch = document.querySelector('.search-row.no-search');

  }
  close() {
    this.predictiveSearchResults.style.display = 'none';
    document.querySelectorAll('.no-search').forEach(el => {
      el.style.display = 'flex';
    });
  }
  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
customElements.define('predictive-search', PredictiveSearch);
if(document.querySelectorAll('.menu-burdger,.close-menu')) document.querySelectorAll('.menu-burdger,.close-menu').forEach(function(menuBurger){
  menuBurger.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-menu');
    if(document.querySelector('body').classList.contains('open-menu')){
      lenis.stop();
    }else{
      lenis.start();
    }
    const drawer = document.querySelector('.snippet-menu-drawer')
    drawer.addEventListener('wheel', e => e.stopPropagation());
    document.querySelector('body').classList.remove('open-drawer','open-search','open-sort','open-filter');    
  });
});
if(document.querySelectorAll('.mobile-search')) document.querySelectorAll('.mobile-search').forEach(function(searchButton){
  searchButton.addEventListener('click',function(e){
    document.querySelector('body').classList.toggle('open-search');
    lenis.stop();
    const drawer = document.querySelector('.bottom')
    drawer.addEventListener('wheel', e => e.stopPropagation());
    // drawer.addEventListener('touchstart', (e) => {
    //   e.stopPropagation();
    // }, { passive: false });

    // drawer.addEventListener('touchmove', (e) => {
    //   e.stopPropagation();
    // }, { passive: false });

    initSearchRowSwipers();
    document.querySelector('body').classList.remove('open-drawer','open-menu','open-sort','open-filter');
    document.querySelector("#Search").focus();
  });
});
if(document.querySelector('.overlay-box')) document.querySelector('.overlay-box').addEventListener('click',function(e){
  document.querySelector('body').classList.remove('open-menu');
});
if(document.querySelectorAll('.variant-grid')){
  function quickAddButton(){
    // document.querySelectorAll('.variant-grid').forEach(function(sizeList){
    //   sizeList.addEventListener('click',function(e){
    //     e.preventDefault();
    //     let variant_id = sizeList.dataset.id;
    //     let error_grid_outer = sizeList.closest('.snippet-product-grid');
    //     let error_grid = error_grid_outer.querySelector('.grid-error');
    //     let formData = {
    //       'items': [{
    //         'id': variant_id,
    //         'quantity': 1
    //       }]
    //     };
    //     fetch('/cart/add.js', {
    //       method: 'POST',
    //       headers: {
    //         'Content-Type': 'application/json',
    //       },
    //       body: JSON.stringify(formData),
    //     })
    //     .then((response) => response.json())
    //     .then((data) => {
    //       if(data.status == 422)
    //       {
    //         error_grid.innerHTML = data.description;
    //         setTimeout(function(e){
    //           error_grid.innerHTML = '';
    //         },2000);
    //       }else{          
    //         if(document.location.href.indexOf('/cart') > -1) {
    //           window.location.href = "/cart";
    //         }else{
    //           if(typeof load_cart == 'function'){
    //             load_cart();
    //             setTimeout(function(e){
    //               document.querySelector('body').classList.add('open-drawer');
    //             },500);
    //           }else{
    //             window.location.href = "/cart";
    //           }          
    //         }
    //         const url = '/cart.js';
    //         fetch(url)
    //         .then((resp) => resp.json())
    //         .then(function(data) {
    //           var cart_count = data.item_count;
    //           document.querySelector('.cart-count').innerHTML = cart_count;
    //         })
    //         .catch(function(error) {
    //           console.log(error);
    //         })
    //       }
    //     })
    //     .catch((error) => {
    //       console.error(error);
    //     });
    //   });
    // });    
    document.querySelectorAll('.variant-grid').forEach(function (sizeList) {
      sizeList.addEventListener('click', function (e) {
        e.preventDefault();

        let variant_id = sizeList.dataset.id;
        let error_grid_outer = sizeList.closest('.snippet-product-grid');
        let error_grid = error_grid_outer.querySelector('.grid-error');

        let formData = {
          items: [
            {
              id: variant_id,
              quantity: 1,
            },
          ],
        };

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        })
          .then((response) => response.json())
          .then((data) => {
            // ----- Handle Error -----
            if (data.status == 422) {
              error_grid.innerHTML = data.description;
              setTimeout(function () {
                error_grid.innerHTML = '';
              }, 2000);
              return;
            }

            // ----- If Success -----
            if (document.location.href.indexOf('/cart') > -1) {
              window.location.href = '/cart';
            } else {
              if (typeof load_cart == 'function') {
                load_cart();
                // setTimeout(function () {
                //   document.querySelector('body').classList.add('open-drawer');
                // }, 500);
              } else {
                window.location.href = '/cart';
              }
            }

            // ----- Update Cart Count -----
            fetch('/cart.js')
              .then((resp) => resp.json())
              .then(function (data) {
                var cart_count = data.item_count;
                document.querySelector('.cart-count').innerHTML = cart_count;
              })
              .catch(function (error) {
                console.log(error);
              });

            // ----- CART NOTIFICATION -----
            const title = sizeList.getAttribute('data-pro-title') || '';
            const imgSrc = sizeList.getAttribute('data-img-src') || '';

            const cartPopup = document.getElementById('cart-popup');
            const popupTitle = document.getElementById('cart-popup-title');
            const popupImage = document.getElementById('cart-popup-image');
            const popupClose = document.querySelector('.cart-popup-close');

            let popupTimer;

            if (cartPopup && popupTitle && popupImage) {
              popupTitle.textContent = title;
              popupImage.src = imgSrc;

              // Show popup
              cartPopup.classList.remove('hidden');
              cartPopup.classList.add('visible');

              clearTimeout(popupTimer);

              // Hide after 3s
              popupTimer = setTimeout(() => {
                cartPopup.classList.remove('visible');
                setTimeout(() => cartPopup.classList.add('hidden'), 300);
              }, 3000);
            }

            // Manual close (attach once)
            if (popupClose && !popupClose.hasListener) {
              popupClose.addEventListener('click', function () {
                clearTimeout(popupTimer);
                cartPopup.classList.remove('visible');
                setTimeout(() => cartPopup.classList.add('hidden'), 300);
              });
              popupClose.hasListener = true;
            }
          })
          .catch((error) => {
            console.error(error);
          });
      });
    });

    
//     document.querySelectorAll('.quick-add').forEach(function(quickAdd){
//       quickAdd.onclick = function(){
//         document.querySelectorAll('.snippet-product-grid').forEach(function(everyProduct){       
//           everyProduct.classList.remove('active-quick');
//         });
//         let gridimgbox = quickAdd.closest('.snippet-product-grid');      
//         gridimgbox.classList.add('active-quick');
//       };
//     });
  }
  quickAddButton();
}
if(document.querySelector('.nav-arrow')){
  document.querySelectorAll('.nav-arrow').forEach(function(navArrow){
    navArrow.addEventListener('click',function(e){
      navArrow.closest('li').classList.toggle('active');
    });
  });
}
// if(document.querySelector('.list-menu')){
//   document.querySelectorAll('.list-menu > li').forEach(function(navList){
//     navList.addEventListener('mouseover', function(){
//       navList.classList.add('active');
//     });
//     navList.addEventListener('mouseout', function(){
//       navList.classList.remove('active');
//     });
//   });
// }
// ------------------------------------------------------------------------------------------------------------



// -----------------------------------------------
if (document.querySelector('.list-menu')) {
  const header = document.querySelector('.section-header');
  const announcementBar = document.querySelector('.section-announcement-bar');
  const body = document.body;

  // Create or reuse <style> for background updates
  let styleTag = document.getElementById('megaMenuDynamicStyle');
  if (!styleTag) {
    styleTag = document.createElement('style');
    styleTag.id = 'megaMenuDynamicStyle';
    document.head.appendChild(styleTag);
  }

  function closeMegaMenu(menuItem) {
    if (!menuItem) return;

    menuItem.classList.remove('active');

    const openMega = menuItem.querySelector('.megamenu');
    if (openMega) {
      openMega.style.top = '';
      openMega.style.maxHeight = '0';
    }

    const mediaContent = menuItem.querySelector('.mega-img-single-child .media-content');
    if (mediaContent) {
      mediaContent.style.top = '';
      mediaContent.style.height = '';
    }

    // Remove body class and dynamic styles only if no menus remain open
    if (!document.querySelector('.list-menu .mega-list.active')) {
      body.classList.remove('open-mega-menu');
      lenis.start();
      styleTag.textContent = '';
    }
  }

  function closeAllMegaMenus() {
    document.querySelectorAll('.list-menu .mega-list.active').forEach(function (item) {
      closeMegaMenu(item);
    });
  }

  document.querySelector('.close-mega').addEventListener('click', function () {
    closeAllMegaMenus();
  });

  

  // --- Click ONLY on specific trigger to open mega menu ---
  document.querySelectorAll('.list-menu .mega-list > a').forEach(function (trigger) {
    let header_height = header ? header.offsetHeight : 0;
    let announcement_height = 0;
    let top_offset = header_height;
    const navList = trigger.parentElement;
    const megaMenu = navList.querySelector('.megamenu');

    if (body.contains(announcementBar) && announcementBar && announcementBar.offsetParent !== null) {
      announcement_height = announcementBar.offsetHeight;
      top_offset = header_height + announcement_height;
    }

    const available_height = window.innerHeight - (header_height + announcement_height);
    megaMenu.style.top = top_offset + 'px';
    // megaMenu.style.maxHeight = available_height + 'px';
     megaMenu.style.maxHeight = '';
    console.log("available_height",available_height);

    if(trigger.closest('.mega-list').querySelector('.megamenu .mega-main-bottom')) trigger.closest('.mega-list').querySelector('.megamenu .mega-main-bottom').style.height = (available_height - trigger.closest('.mega-list').querySelector('.megamenu .mega-main-top').offsetHeight) +'px';
    if(trigger.closest('.mega-list').querySelectorAll('.megamenu .media-block')) trigger.closest('.mega-list').querySelectorAll('.megamenu .media-block').forEach(block => {
      block.style.height = (available_height - trigger.closest('.mega-list').querySelector('.megamenu .mega-main-top').offsetHeight) +'px';
    });

    trigger.addEventListener('click', function (e) {
      collectionslider();
      
      // Close other open menus first
      document.querySelectorAll('.list-menu .mega-list.active').forEach(function (item) {
        if (item !== navList) {
          closeMegaMenu(item);
        }
      });

      const isActive = navList.classList.contains('active');
      if (isActive) {
        return;
      }
       e.preventDefault();
      e.stopPropagation();

      // Open the menu
      navList.classList.add('active');

      if (megaMenu) {
        // --- Calculate header + announcement offset ---
        let headerHeight = header ? header.offsetHeight : 0;
        let announcementHeight = 0;
        let topOffset = headerHeight;

        if (body.contains(announcementBar) && announcementBar && announcementBar.offsetParent !== null) {
          announcementHeight = announcementBar.offsetHeight;
          topOffset = headerHeight + announcementHeight;
        }

        const availableHeight = window.innerHeight - (headerHeight + announcementHeight);
        megaMenu.style.top = topOffset + 'px';
        megaMenu.style.maxHeight = availableHeight + 'px';

        if(trigger.closest('.mega-list').querySelector('.megamenu .mega-main-bottom')) trigger.closest('.mega-list').querySelector('.megamenu .mega-main-bottom').style.height = (availableHeight - trigger.closest('.mega-list').querySelector('.megamenu .mega-main-top').offsetHeight) +'px';
        if(trigger.closest('.mega-list').querySelectorAll('.megamenu .media-block')) trigger.closest('.mega-list').querySelectorAll('.megamenu .media-block').forEach(block => {
          block.style.height = (availableHeight - trigger.closest('.mega-list').querySelector('.megamenu .mega-main-top').offsetHeight) +'px';
        });

        body.classList.add('open-mega-menu');
        lenis.stop();

        // --- Set media-content height accurately ---
        const singal_top_div = megaMenu.querySelector('.mega-main-top');
        const mediaContents = megaMenu.querySelectorAll('.mega-img-single-child .media-content');
        const collectionbanner = megaMenu.querySelectorAll('.mega-collections .media-block');

        if (singal_top_div && mediaContents.length > 0) {
          const topDivHeight = singal_top_div.offsetHeight;

          mediaContents.forEach(mediaContent => {
            const mediaComputed = window.getComputedStyle(mediaContent);
            const paddingTop = parseFloat(mediaComputed.paddingTop) || 0;
            const paddingBottom = parseFloat(mediaComputed.paddingBottom) || 0;
            const margins = paddingTop + paddingBottom;

            mediaContent.style.top = topDivHeight + 'px';
            const availableHeightInner = window.innerHeight - (topOffset + topDivHeight);
            mediaContent.style.height = availableHeightInner + 'px';
          });

          collectionbanner.forEach(collectionbanners => {
            const mediaComputed = window.getComputedStyle(collectionbanners);
            const paddingTop = parseFloat(mediaComputed.paddingTop) || 0;
            const paddingBottom = parseFloat(mediaComputed.paddingBottom) || 0;
            const margins = paddingTop + paddingBottom;

            collectionbanners.style.top = topDivHeight + 'px';
            const availableHeightInner = window.innerHeight - (topOffset + topDivHeight);
            collectionbanners.style.height = availableHeightInner + 'px';
          });
        }

        
        // --- Background image logic ---
        const imgBlock = navList.querySelector('.mega-img-single-child .media-block');
        if (imgBlock && imgBlock.dataset.src) {
          const bgUrl = imgBlock.dataset.src;
          styleTag.textContent = `
            .open-mega-menu .header-group::after {
              background-image: url('${bgUrl}');
            }
          `;
        } else {
          styleTag.textContent = '';
        }
      }

    });
  });


  document.addEventListener("DOMContentLoaded", () => {
  const mediaBlocks = document.querySelectorAll(".mega-collections-wrap .media-block");
  const body = document.body;

  mediaBlocks.forEach(block => {
    block.addEventListener("mouseenter", () => {
      const src = block.getAttribute("data-src");
      if (src) {
        body.style.setProperty("--bg-url", `url(${src})`);
        document.styleSheets[0].insertRule(`
          body::after {
            background-image: url(${src});
          }
        `, document.styleSheets[0].cssRules.length);
      }
    });

    block.addEventListener("mouseleave", () => {
      body.style.removeProperty("--bg-url");
      document.styleSheets[0].insertRule(`
        body::after {
          background-image: none;
        }
      `, document.styleSheets[0].cssRules.length);
    });
  });
});


  // --- Add click event to mega-close buttons ---
  document.addEventListener('click', function (e) {
    // Check if the clicked element is a mega-close button
    if (e.target.closest('.mega-close')) {
      e.preventDefault();
      e.stopPropagation();
      closeAllMegaMenus();
    }
  });

  function collectionslider(){
    const swiper = new Swiper( '.mega-collectionslider', {
      spaceBetween: 1,
      slidesPerView: 3.65,
      freeMode: true,
      freeModeMomentumRatio: 0.85,   
      freeModeMinimumVelocity: 0.02, 
      followFinger: true,
      loop: false,
      mousewheel: {
        forceToAxis: true,
        releaseOnEdges: true,
        sensitivity: 1,
        thresholdDelta: 1,
        thresholdTime: 200
      },
    } );
  }

  // --- Media switch on hover ---
  document.querySelectorAll('.mega-listmenu li').forEach(function (listItem) {
    listItem.addEventListener('mouseenter', function () {
      const dataId = listItem.getAttribute('data-id');
      const megaMenu = listItem.closest('.megamenu');
      if (!megaMenu) return;

      const defaultWrapper = megaMenu.querySelector('.mega-media-wrapper');
      const defaultCollection = megaMenu.querySelector('.mega-collections-wrap');
      const allMediaBlocks = megaMenu.querySelectorAll('.media-block-inner');
      const targetBlock = megaMenu.querySelector(`.media-block-inner[data-id="${dataId}"]`);

      // Hide all custom blocks first
      allMediaBlocks.forEach(el => el.style.display = 'none');

      if (targetBlock) {
        // ✅ Match made → show custom block
        if (defaultWrapper) defaultWrapper.style.display = 'none';
        if (defaultCollection) defaultCollection.style.display = 'none';

        targetBlock.style.display = 'block';

        const bgSrc = targetBlock.dataset.src;
        if (bgSrc) {
          styleTag.textContent = `
            .open-mega-menu .header-group::after {
              background-image: url('${bgSrc}');
            }
          `;
        }
      } else {
        // ✅ Match NOT found → show defaults again
        if (defaultWrapper) defaultWrapper.style.display = 'block';
        if (defaultCollection) defaultCollection.style.display = 'block';

        // reset bg
        const imgBlock = megaMenu.closest('li').querySelector('.mega-img-single-child .media-block');
        if (imgBlock && imgBlock.dataset.src) {
          styleTag.textContent = `
            .open-mega-menu .header-group::after {
              background-image: url('${imgBlock.dataset.src}');
            }
          `;
        } else {
          styleTag.textContent = '';
        }
      }
    });

    listItem.addEventListener('mouseleave', function () {
      const megaMenu = listItem.closest('.megamenu');
      if (!megaMenu) return;

      // hide all custom blocks
      megaMenu.querySelectorAll('.media-block-inner').forEach(el => {
        el.style.display = 'none';
      });

      // ✅ Always show default on mouse leave
      const defaultWrapper = megaMenu.querySelector('.mega-media-wrapper');
      const defaultCollection = megaMenu.querySelector('.mega-collections-wrap');

      if (defaultWrapper) defaultWrapper.style.display = 'block';
      if (defaultCollection) defaultCollection.style.display = 'block';

      // reset bg
      const imgBlock = megaMenu.closest('li').querySelector('.mega-img-single-child .media-block');
      if (imgBlock && imgBlock.dataset.src) {
        styleTag.textContent = `
          .open-mega-menu .header-group::after {
            background-image: url('${imgBlock.dataset.src}');
          }
        `;
      } else {
        styleTag.textContent = '';
      }
    });
  });

  
  // document.querySelectorAll('.mega-listmenu li').forEach(function (listItem) {
  //   listItem.addEventListener('mouseenter', function () {
  //     const dataId = listItem.getAttribute('data-id');
  //     const megaMenu = listItem.closest('.megamenu');
  //     if (!megaMenu) return;

  //     const defaultWrapper = megaMenu.querySelector('.mega-media-wrapper');
  //     const defaultcollection = megaMenu.querySelector('.mega-collections-wrap');
  //     const allMediaBlocks = megaMenu.querySelectorAll('.media-block-inner');
  //     const targetBlock = megaMenu.querySelector(`.media-block-inner[data-id="${dataId}"]`);

  //     // Hide all custom media blocks first
  //     allMediaBlocks.forEach(el => (el.style.display = 'none'));

  //     if (targetBlock) {
  //       if (defaultWrapper) defaultWrapper.style.display = 'none';
  //       if (defaultcollection) defaultcollection.style.display = 'none';
  //       targetBlock.style.display = 'block';

  //       // Update background
  //       const bgSrc = targetBlock.dataset.src;
  //       if (bgSrc) {
  //         styleTag.textContent = `
  //           .open-mega-menu .header-group::after {
  //             background-image: url('${bgSrc}');
  //           }
  //         `;
  //       }
  //     } else {
  //       if (defaultWrapper) defaultWrapper.style.display = 'block';
  //       if (defaultcollection) defaultcollection.style.display = 'block';

  //       // Restore default background
  //       const imgBlock = megaMenu.closest('li').querySelector('.mega-img-single-child .media-block');
  //       if (imgBlock && imgBlock.dataset.src) {
  //         styleTag.textContent = `
  //           .open-mega-menu .header-group::after {
  //             background-image: url('${imgBlock.dataset.src}');
  //           }
  //         `;
  //       } else {
  //         styleTag.textContent = '';
  //       }
  //     }
  //   });

  //   listItem.addEventListener('mouseleave', function () {
  //     const megaMenu = listItem.closest('.megamenu');
  //     if (!megaMenu) return;

  //     // Hide all .media-block-inner
  //     megaMenu.querySelectorAll('.media-block-inner').forEach(el => {
  //       el.style.display = 'none';
  //     });

  //     // Show default wrapper again
  //     const defaultWrapper = megaMenu.querySelector('.mega-media-wrapper');
  //     if (defaultWrapper) defaultWrapper.style.display = 'block';

  //     // Restore original background
  //     const imgBlock = megaMenu.closest('li').querySelector('.mega-img-single-child .media-block');
  //     if (imgBlock && imgBlock.dataset.src) {
  //       styleTag.textContent = `
  //         .open-mega-menu .header-group::after {
  //           background-image: url('${imgBlock.dataset.src}');
  //         }
  //       `;
  //     } else {
  //       styleTag.textContent = '';
  //     }
  //   });
  // });
}

// --------------------

document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
    isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
    isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    document.querySelector('body').classList.remove('open-filter','open-sort','open-drawer','open-menu','open-search');
  }
};

//----------------------------------------------    water ripple
$(document).ready(function () {
  $('.water-ripple').ripples({
    resolution: 300,
    dropRadius:30,
    perturbance: 0.05,
    interactive: true,
  });
});

//----------------------------------------------------  parallax effect 

// document.documentElement.style.scrollBehavior = 'smooth';
// document.body.style.scrollBehavior = 'smooth';

// const easing = 0.08;
// const lerp = (start, end, t) => start * (1 - t) + end * t;
// const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);

//   const cards = document.querySelectorAll('.parallax-card');
//   let currentY = window.scrollY;
//   let targetY = window.scrollY;
//   let velocity = 0;

//   function updateScroll() {
//     targetY = window.scrollY;
    
//     const distance = targetY - currentY;
//     velocity = lerp(velocity, distance * easing, 0.1);
//     currentY = lerp(currentY, targetY, easing);

//     cards.forEach((card) => {
//       const wrapper = card.querySelector('.media');
//       if (!wrapper) return;

//       const diff = 100;
//       const rect = card.getBoundingClientRect();
//       const progress = rect.top / window.innerHeight;
//       const smoothProgress = easeOutQuart(Math.max(0, Math.min(1, (1 - progress))));
//       const yPos = diff * progress;
//       wrapper.style.transform = `translate3d(0px, ${yPos}px, 0px)`;
//       wrapper.style.willChange = 'transform';
//       wrapper.style.transition = 'transform 0.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)';
//     });

//     requestAnimationFrame(updateScroll);
//   }

//   requestAnimationFrame(updateScroll);

//   window.addEventListener('resize', () => {
//     currentY = targetY = window.scrollY;
//     velocity = 0;
//   });
// ====================

document.documentElement.style.scrollBehavior = 'smooth';
document.body.style.scrollBehavior = 'smooth';

// const sections = document.querySelectorAll(".shopify-section");

// function updateParallax() {
//   sections.forEach((section, index) => {
//     const medias = section.querySelectorAll(".parallax-card .media");
//     if (!medias.length) return; // skip if no parallax cards

//     const prevSection = sections[index - 1];
//     const nextSection = sections[index + 1];
//     if (!prevSection || !nextSection) return; // first & last sections skip

//     const prevRect = prevSection.getBoundingClientRect();
//     const nextRect = nextSection.getBoundingClientRect();

//     // total distance = prevSection top (0) → nextSection top (0)
//     const total = nextRect.top - prevRect.top;
//     // how much scrolled since prevSection reached top
//     const scrolled = -prevRect.top;

//     let progress = scrolled / total; // 0 → 1
//     progress = Math.max(0, Math.min(1, progress));

//     // Map to -100 → +100
//     const translateY = (progress * 200) - 100;

//     medias.forEach((media) => {
//       media.style.transform = `translate3d(0, ${translateY}px, 0)`;
//     });
//   });
// }
const sections = Array.from(document.querySelectorAll('.shopify-section'));
let ticking = false;
const initiallyVisible = new Set();

function clamp(v, min, max) {
  return Math.max(min, Math.min(max, v));
}

function updateParallax() {
  const nowScroll = window.scrollY;
  const winH = window.innerHeight;
  const winW = window.innerWidth;

  sections.forEach((section, index) => {
    const lrows = Array.from(section.querySelectorAll('.lrow-parallax-card .media'));
    const medias = Array.from(section.querySelectorAll('.parallax-card .media'));

    if (!medias.length) return;

    const rect = section.getBoundingClientRect();
    const nextSection = sections[index + 1];
    const docNextTop = nextSection ? window.scrollY + nextSection.getBoundingClientRect().top : document.body.scrollHeight;

    // mark section as initially visible on load
    if (rect.top < winH && rect.bottom > 0 && nowScroll === 0) {
      initiallyVisible.add(section);
    }

    medias.forEach((m) => {
      const card = m.closest('.parallax-card');
      if (!card) return;

      const hasSrow = card.classList.contains('srow-parallax-card');
      const hasLrow = card.classList.contains('lrow-parallax-card');

      let translateY = 0;
      let range = { start: -100, end: 100 };
      let initialRange = { start: 0, end: 100 };

      // 🔹 srow special case (mobile only)
      if (hasSrow && winW <= 991) {
        range = { start: -15, end: 15 };
        initialRange = { start: 0, end: 15 };
      }

      // 🔹 lrow case (mobile only, ≤991px)
      if (hasLrow && winW <= 991) {

        const rectM = card.getBoundingClientRect();
        const cardTop = nowScroll + rectM.top;
        const cardBottom = nowScroll + rectM.bottom;

        // start when card bottom enters viewport bottom
        const startDoc = cardBottom - winH;
        // end when card top reaches top 0
        const endDoc = cardTop;

        const denom = endDoc - startDoc;
        const progress = denom <= 0 ? 0 : clamp((nowScroll - startDoc) / denom, 0, 1);
        translateY = -40 + progress * 80;
        
        // const lrowCards = Array.from(section.querySelectorAll('.lrow-parallax-card'));
        // const idx = lrowCards.indexOf(card);

        // if (idx === 0) {
        //   // First lrow → 0 → 100
        //   const startDoc = window.scrollY + rect.top; // section top
        //   const next = lrowCards[idx + 1];
        //   const endDoc = next
        //     ? window.scrollY + next.getBoundingClientRect().top
        //     : docNextTop;

        //   const denom = endDoc - startDoc;
        //   const progress = denom <= 0 ? 0 : clamp((nowScroll - startDoc) / denom, 0, 1);
        //   translateY = 0 + progress * 100;
        // } else {
        //   // Other lrows → -100 → 100
        //   const prev = lrowCards[idx - 1];
        //   const startDoc = prev
        //     ? window.scrollY + prev.getBoundingClientRect().top
        //     : window.scrollY + rect.top;
        //   const next = lrowCards[idx + 1];
        //   const endDoc = next
        //     ? window.scrollY + next.getBoundingClientRect().top
        //     : docNextTop;

        //   const denom = endDoc - startDoc;
        //   const progress = denom <= 0 ? 0 : clamp((nowScroll - startDoc) / denom, 0, 1);
        //   translateY = -100 + progress * 200; // -100 → +100
        // }
      } else if (!hasLrow || winW > 991) {
        // 🔹 Normal parallax (desktop or other cards)
        if (initiallyVisible.has(section)) {
          // visible on load → initialRange
          const startDoc = 0;
          const endDoc = docNextTop;
          const denom = endDoc - startDoc;
          const progress = denom <= 0 ? 0 : clamp((nowScroll - startDoc) / denom, 0, 1);
          translateY = initialRange.start + progress * (initialRange.end - initialRange.start);
        } else {
          // normal flow
          const prevSection = sections[index - 1];
          const startDoc = prevSection
            ? window.scrollY + prevSection.getBoundingClientRect().top
            : window.scrollY + rect.top;
          const endDoc = docNextTop;
          const denom = endDoc - startDoc;
          const progress = denom <= 0 ? 0 : clamp((nowScroll - startDoc) / denom, 0, 1);
          translateY = range.start + progress * (range.end - range.start);
        }
      }

      m.style.transform = `translate3d(0, ${translateY}px, 0)`;
      m.style.willChange = 'transform';
    });
  });

  ticking = false;
}

function onScroll() {
  if (!ticking) {
    ticking = true;
    requestAnimationFrame(updateParallax);
  }
}

window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', updateParallax);
updateParallax();


// const sections = Array.from(document.querySelectorAll('.shopify-section'));
// let ticking = false;
// const initiallyVisible = new Set();

// function clamp(v, min, max) {
//   return Math.max(min, Math.min(max, v));
// }

// function updateParallax() {
//   const nowScroll = window.scrollY;
//   const winH = window.innerHeight;

//   sections.forEach((section, index) => {
//     const medias = section.querySelectorAll('.parallax-card .media');
//     if (!medias.length) return;

//     const rect = section.getBoundingClientRect();
//     const nextSection = sections[index + 1];
//     if (!nextSection) return;

//     const nextRect = nextSection.getBoundingClientRect();
//     const docNextTop = window.scrollY + nextRect.top;

//     let translateY = 0;

//     // mark section as initially visible
//     if (rect.top < winH && rect.bottom > 0 && nowScroll === 0) {
//       initiallyVisible.add(section);
//     }

//     if (initiallyVisible.has(section)) {
//       // 🔹 Section visible at load → start = 0 → +100
//       const startDoc = 0;
//       const endDoc = docNextTop;
//       const progress = clamp((nowScroll - startDoc) / (endDoc - startDoc), 0, 1);
//       translateY = progress * 100;
//     } else {
//       // 🔹 Normal flow → start when prev top = 0, end when next top = 0
//       const prevSection = sections[index - 1];
//       if (!prevSection) return;

//       const prevRect = prevSection.getBoundingClientRect();
//       const startDoc = window.scrollY + prevRect.top; // prev top = 0
//       const endDoc = docNextTop; // next top = 0

//       const progress = clamp((nowScroll - startDoc) / (endDoc - startDoc), 0, 1);
//       translateY = (progress * 200) - 100; // -100 → +100
//     }

//     medias.forEach((m) => {
//       m.style.transform = `translate3d(0, ${translateY}px, 0)`;
//       m.style.willChange = 'transform';
//     });
//   });

//   ticking = false;
// }

// function onScroll() {
//   if (!ticking) {
//     ticking = true;
//     requestAnimationFrame(updateParallax);
//   }
// }

// window.addEventListener('scroll', onScroll, { passive: true });
// window.addEventListener('resize', updateParallax);
// updateParallax();
// -------------------------------------------------------------

// window.addEventListener("scroll", updateParallax);
// window.addEventListener("resize", updateParallax);
// updateParallax();


  // const easing = 0.08;
  // const lerp = (start, end, t) => start * (1 - t) + end * t;
  // const easeOutQuart = (t) => 1 - Math.pow(1 - t, 4);

  // const cards = document.querySelectorAll('.parallax-card');
  // let currentY = window.scrollY;
  // let targetY = window.scrollY;
  // let velocity = 0;

  // function updateScroll() {
  //   targetY = window.scrollY;
    
  //   const distance = targetY - currentY;
  //   velocity = lerp(velocity, distance * easing, 0.1);
  //   currentY = lerp(currentY, targetY, easing);

  // cards.forEach((card) => {
  //   const wrapper = card.querySelector('.media');
  //   if (!wrapper) return;

  //   const rect = card.getBoundingClientRect();
  //   const cardMid = rect.top + rect.height / 2;
  //   const viewportMid = window.innerHeight / 2;

  //   if (cardMid < window.innerHeight) {
  //     const diff = 50; 
  //     const speed = 0.6; // 👈 tweak this to make parallax slower/faster
  //     const progress = (viewportMid - cardMid) / viewportMid;
  //     const clamped = Math.max(0, Math.min(1, progress));
  //     const smoothProgress = easeOutQuart(clamped);

  //     const yPos = diff * smoothProgress * speed;
  //     wrapper.style.transform = `translate3d(0px, ${yPos}px, 0px)`;
  //     wrapper.style.willChange = 'transform';
  //   } else {
  //     wrapper.style.transform = `translate3d(0px, 0px, 0px)`;
  //   }
  // });

  //   requestAnimationFrame(updateScroll);
  // }

  // requestAnimationFrame(updateScroll);

  // window.addEventListener('resize', () => {
  //   currentY = targetY = window.scrollY;
  //   velocity = 0;
  // });




// -------------------------------------------   logo animation 


if (document.querySelector('.header-logo')) {
  const scaleReduction = 0.1;
  const logoLink = document.querySelector('.header-logo a');
  const logoContainer = document.querySelector('.header-logo');
  const heroWrapper = document.querySelector('.hero-section-wrapper');
  const sectionHeader = document.querySelector('.section-header');
  const fullBanner = document.querySelector('.full-banner-wrapper');

  if (logoLink && logoContainer && heroWrapper && sectionHeader && fullBanner) {
    const initialWidth = 100; 
    const initialTop = 50;  
    let finalWidth;
    let finalTop;
    let maxScroll;
    let viewportHeight; 
    let headerMidPercent;
    let headerMidLocked = false; 
    let lockedViewportHeight; 
    let logoLocked = false; // NEW

    function getScrollY() {
      return window.pageYOffset || document.documentElement.scrollTop;
    }

    function setViewportHeight() {
      viewportHeight = window.innerHeight;
      if (!lockedViewportHeight) {
        lockedViewportHeight = viewportHeight; 
      }
    }

    function calculateHeaderMidPercent() {
      const headerRect = sectionHeader.getBoundingClientRect();
      const headerTop = headerRect.top + getScrollY();
      const headerHeight = sectionHeader.offsetHeight;
      const headerMid = headerTop + headerHeight / 2;
      return (headerMid / lockedViewportHeight) * 100; 
    }

    function setFinalValues() {
      if (window.innerWidth <= 991) {
        finalWidth = 96; 
      } else {
        finalWidth = 55;  
      }

      if (!headerMidLocked) {
        headerMidPercent = calculateHeaderMidPercent();
        finalTop = headerMidPercent;
        headerMidLocked = true;
      }
    }

    function setMaxScroll() {
      const heroHeight = heroWrapper.offsetHeight;
      maxScroll = heroHeight - lockedViewportHeight * 0.5; 
    }

    function updateLogoOnScroll() {
      const scrollY = getScrollY();

      // --- check if banner reached top ---
      const bannerTop = fullBanner.getBoundingClientRect().top;
      if (bannerTop <= 0) {
        if (!logoLocked) {
          // lock logo at final position
          logoLink.style.width = finalWidth + "%";
          logoContainer.style.top = (finalTop / 100) * lockedViewportHeight + "px";
          logoContainer.style.transform = `translate(-50%, -50%) scale(${1 - scaleReduction})`;
          logoLocked = true;
        }
        return; // stop updates
      } else {
        logoLocked = false;
      }

      // --- normal smooth animation ---
      const scrollProgress = Math.min(scrollY / maxScroll, 1);
      const newWidth = initialWidth - (initialWidth - finalWidth) * scrollProgress;
      const newTop = initialTop - (initialTop - finalTop) * scrollProgress;
      const scale = 1 - scrollProgress * scaleReduction;

      logoLink.style.width = newWidth + "%";
      logoContainer.style.top = (newTop / 100) * lockedViewportHeight + "px"; 
      logoContainer.style.transform = `translate(-50%, -50%) scale(${scale})`;
    }

    // Init
    setViewportHeight();
    setFinalValues();
    setMaxScroll();
    updateLogoOnScroll();

    // Smooth scroll listener
    let ticking = false;
    window.addEventListener("scroll", () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          updateLogoOnScroll();
          ticking = false;
        });
        ticking = true;
      }
    });

    // Orientation change listener (not resize)
    window.addEventListener("orientationchange", () => {
      lockedViewportHeight = null; // reset
      setViewportHeight();
      headerMidLocked = false;
      setFinalValues();
      setMaxScroll();
      updateLogoOnScroll();
    });
  }
}


// if (document.querySelector('.header-logo')) {
//   const scaleReduction = 0.1;
//   const logoLink = document.querySelector('.header-logo a');
//   const logoContainer = document.querySelector('.header-logo');
//   const heroWrapper = document.querySelector('.hero-section-wrapper');
//   const sectionHeader = document.querySelector('.section-header');

//   if (logoLink && logoContainer && heroWrapper && sectionHeader) {
//     const initialWidth = 100; 
//     const initialTop = 50;  
//     let finalWidth;
//     let finalTop;
//     let maxScroll;
//     let viewportHeight; 
//     let headerMidPercent;
//     let headerMidLocked = false; 
//     let lockedViewportHeight; 

//     function getScrollY() {
//       return window.pageYOffset || document.documentElement.scrollTop;
//     }

//     function setViewportHeight() {
//       viewportHeight = window.innerHeight;
//       if (!lockedViewportHeight) {
//         lockedViewportHeight = viewportHeight; 
//       }
//     }

//     function calculateHeaderMidPercent() {
//       const headerRect = sectionHeader.getBoundingClientRect();
//       const headerTop = headerRect.top + getScrollY();
//       const headerHeight = sectionHeader.offsetHeight;
//       const headerMid = headerTop + headerHeight / 2;
//       return (headerMid / lockedViewportHeight) * 100; 
//     }

//     function setFinalValues() {
//       if (window.innerWidth <= 991) {
//         finalWidth = 96; 
//       } else {
//         finalWidth = 55;  
//       }

//       if (!headerMidLocked) {
//         headerMidPercent = calculateHeaderMidPercent();
//         finalTop = headerMidPercent;
//         headerMidLocked = true;
//       }
//     }

//     function setMaxScroll() {
//       const heroHeight = heroWrapper.offsetHeight;
//       maxScroll = heroHeight - lockedViewportHeight * 0.5; 
//     }

//     function updateLogoOnScroll() {
//       const scrollY = getScrollY();
//       const scrollProgress = Math.min(scrollY / maxScroll, 1);

//       const newWidth = initialWidth - (initialWidth - finalWidth) * scrollProgress;
//       const newTop = initialTop - (initialTop - finalTop) * scrollProgress;
//       const scale = 1 - scrollProgress * scaleReduction;

//       logoLink.style.width = newWidth + "%";
//       logoContainer.style.top = (newTop / 100) * lockedViewportHeight + "px"; 
//       logoContainer.style.transform = `translate(-50%, -50%) scale(${scale})`;
//     }

//     // Init
//     setViewportHeight();
//     setFinalValues();
//     setMaxScroll();
//     updateLogoOnScroll();

//     // Smooth scroll listener
//     let ticking = false;
//     window.addEventListener("scroll", () => {
//       if (!ticking) {
//         requestAnimationFrame(() => {
//           updateLogoOnScroll();
//           ticking = false;
//         });
//         ticking = true;
//       }
//     });

//     // Orientation change listener (not resize)
//     window.addEventListener("orientationchange", () => {
//       lockedViewportHeight = null; // reset
//       setViewportHeight();
//       headerMidLocked = false;
//       setFinalValues();
//       setMaxScroll();
//       updateLogoOnScroll();
//     });
//   }
// }

// ---------------------------------------------- lenis
const lenis = new Lenis({
  autoRaf: true,
  lerp: 0.03,
  easing: (t) => 1 - Math.pow(1 - t, 3),
  wheelMultiplier: 0.5,
  smoothTouch: true,
  touchMultiplier: 1.4,
  syncTouch: false,
});

// ----------------------------------------------  reaveal effect  [data-reveal]

class BlurRevealEffect {
    constructor() {
        this.containers = document.querySelectorAll('.blur-reveal-container');
        this.trailPoints = new Map(); // Store trail points for each container
        this.animationFrameId = null;
        
        // Detect if device is mobile/touch-enabled
        this.isMobile = this.detectMobile();
        
        // Touch gesture tracking for smart scroll detection
        this.touchStartData = new Map(); // Store initial touch data per container
        this.isInteracting = new Map(); // Track if user is intentionally interacting
        
        // Adjust parameters based on device type
        this.trailDuration = 1500; // Longer fade on mobile
        this.trailDistance = 2; // Smoother trail on mobile
        this.maxTrailLength = this.isMobile ? 80 : 100; // Shorter trail on mobile
        this.revealRadius = this.isMobile ? 25 : 30; // Larger radius for finger vs cursor
        
        // Gesture detection thresholds
        this.scrollSpeedThreshold = 0.8; // pixels per ms - faster = allow scroll
        this.interactionDelay = 100; // ms - time to determine intent
        
        this.init();
    }

    detectMobile() {
        // Check for touch support and mobile characteristics
        return ('ontouchstart' in window) || 
               (navigator.maxTouchPoints > 0) || 
               (navigator.msMaxTouchPoints > 0) ||
               (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent));
    }

    init() {
        this.containers.forEach(container => {
            this.setupContainer(container);
            this.trailPoints.set(container, []);
            this.touchStartData.set(container, null);
            this.isInteracting.set(container, false);
        });
        this.startAnimation();
    }

    setupContainer(container) {
        // Track mouse movement within the container (desktop)
        container.addEventListener('mousemove', (e) => {
            this.addTrailPoint(container, e);
        });

        // Reset trail when mouse leaves (desktop)
        container.addEventListener('mouseleave', () => {
            this.clearTrail(container);
        });

        // Mobile touch events with smart gesture detection
        container.addEventListener('touchstart', (e) => {
            this.handleTouchStart(container, e);
        });

        container.addEventListener('touchmove', (e) => {
            this.handleTouchMove(container, e);
        });

        container.addEventListener('touchend', (e) => {
            this.handleTouchEnd(container, e);
        });

        container.addEventListener('touchcancel', (e) => {
            this.handleTouchEnd(container, e);
        });

        // Initialize trail
        this.clearTrail(container);
    }

    handleTouchStart(container, event) {
        const touch = event.touches[0];
        if (!touch) return;

        // Store initial touch data for speed analysis
        this.touchStartData.set(container, {
            x: touch.clientX,
            y: touch.clientY,
            timestamp: Date.now()
        });
        
        this.isInteracting.set(container, false);
        // Don't prevent default initially - let's analyze the movement first
    }

    handleTouchMove(container, event) {
        const touch = event.touches[0];
        if (!touch) return;

        const startData = this.touchStartData.get(container);
        if (!startData) return;

        const now = Date.now();
        const deltaTime = now - startData.timestamp;
        const deltaX = touch.clientX - startData.x;
        const deltaY = touch.clientY - startData.y;
        const distance = Math.sqrt(deltaX * deltaX + deltaY * deltaY);
        
        // Calculate speed (pixels per millisecond)
        const speed = deltaTime > 0 ? distance / deltaTime : 0;
        
        // Determine if this is a fast gesture (likely scroll) or slow (likely interaction)
        const isFastGesture = speed > this.scrollSpeedThreshold;
        const hasMovedEnoughToAnalyze = distance > 10;
        const hasWaitedEnough = deltaTime > this.interactionDelay;
        
        if (hasMovedEnoughToAnalyze && hasWaitedEnough) {
            if (isFastGesture && !this.isInteracting.get(container)) {
                // Fast movement detected - this is likely a scroll gesture
                // Don't prevent default, let browser handle scrolling
                return;
            } else if (!isFastGesture) {
                // Slow movement detected - this is likely intentional interaction
                this.isInteracting.set(container, true);
                event.preventDefault(); // Prevent scrolling for slow, deliberate movements
                
                // Create synthetic event for the effect
                const syntheticEvent = {
                    clientX: touch.clientX,
                    clientY: touch.clientY
                };
                this.addTrailPoint(container, syntheticEvent);
            }
        } else if (this.isInteracting.get(container)) {
            // Already in interaction mode, continue preventing scroll and updating trail
            event.preventDefault();
            
            const syntheticEvent = {
                clientX: touch.clientX,
                clientY: touch.clientY
            };
            this.addTrailPoint(container, syntheticEvent);
        }
    }

    handleTouchEnd(container, event) {
        // Reset tracking data
        this.touchStartData.set(container, null);
        this.isInteracting.set(container, false);
        // Let trail fade naturally - don't clear immediately
    }

    handleTouch(container, event) {
        // Legacy method - keeping for compatibility but not used with smart detection
        const touch = event.touches[0];
        if (!touch) return;

        const syntheticEvent = {
            clientX: touch.clientX,
            clientY: touch.clientY
        };

        this.addTrailPoint(container, syntheticEvent);
    }

    addTrailPoint(container, event) {
        const rect = container.getBoundingClientRect();
        const x = ((event.clientX - rect.left) / rect.width) * 100;
        const y = ((event.clientY - rect.top) / rect.height) * 100;
        
        // Ensure trail array exists for this container
        let trail = this.trailPoints.get(container);
        if (!trail) {
            trail = [];
            this.trailPoints.set(container, trail);
        }
        
        const now = Date.now();
        
        // Check if we should add a new point (minimum distance threshold)
        if (trail.length === 0 || this.shouldAddPoint(trail[trail.length - 1], { x, y })) {
            trail.push({
                x,
                y,
                timestamp: now,
                opacity: 1
            });
            
            // Limit trail length by removing old points beyond maxTrailLength pixels
            this.limitTrailLength(trail);
        }
        
        // Update the current mouse position for the main reveal circle
        this.updateCurrentPosition(container, x, y);
    }

    shouldAddPoint(lastPoint, newPoint) {
        if (!lastPoint) return true;
        
        const distance = Math.sqrt(
            Math.pow(newPoint.x - lastPoint.x, 2) + 
            Math.pow(newPoint.y - lastPoint.y, 2)
        );
        
        return distance >= this.trailDistance;
    }

    limitTrailLength(trail) {
        if (trail.length < 2) return;
        
        let totalDistance = 0;
        const maxDistance = this.maxTrailLength;
        
        // Calculate distances from the end
        for (let i = trail.length - 1; i > 0; i--) {
            const current = trail[i];
            const previous = trail[i - 1];
            
            const distance = Math.sqrt(
                Math.pow(current.x - previous.x, 2) + 
                Math.pow(current.y - previous.y, 2)
            );
            
            totalDistance += distance;
            
            if (totalDistance > maxDistance) {
                // Remove points beyond the maximum trail length
                trail.splice(0, i);
                break;
            }
        }
    }

    updateCurrentPosition(container, x, y) {
        container.style.setProperty('--mouse-x', `${x}%`);
        container.style.setProperty('--mouse-y', `${y}%`);
    }

    clearTrail(container) {
        // Ensure trail array exists for this container
        let trail = this.trailPoints.get(container);
        if (!trail) {
            trail = [];
            this.trailPoints.set(container, trail);
        } else {
            trail.length = 0;
        }
        this.updateTrailMask(container);
    }

    startAnimation() {
        const animate = () => {
            this.updateTrails();
            this.animationFrameId = requestAnimationFrame(animate);
        };
        animate();
    }

    updateTrails() {
        const now = Date.now();
        
        this.containers.forEach(container => {
            // Ensure trail array exists for this container
            let trail = this.trailPoints.get(container);
            if (!trail) {
                trail = [];
                this.trailPoints.set(container, trail);
                return; // Skip processing if no trail exists
            }
            
            // Update opacity for each trail point based on age
            trail.forEach(point => {
                const age = now - point.timestamp;
                const opacity = Math.max(0, 1 - (age / this.trailDuration));
                point.opacity = opacity;
            });
            
            // Remove completely faded points
            const activeTrail = trail.filter(point => point.opacity > 0);
            this.trailPoints.set(container, activeTrail);
            
            // Update the mask
            this.updateTrailMask(container);
        });
    }

    updateTrailMask(container) {
        // Ensure trail array exists for this container
        let trail = this.trailPoints.get(container);
        if (!trail) {
            trail = [];
            this.trailPoints.set(container, trail);
        }
        // Get current mouse position
        const mouseX = container.style.getPropertyValue('--mouse-x') || '50%';
        const mouseY = container.style.getPropertyValue('--mouse-y') || '50%';
        // Only show the always-visible sharp circle on desktop
        const showCurrentCircle = !this.isMobile;
        const currentCircle = `radial-gradient(circle ${this.revealRadius}px at ${mouseX} ${mouseY}, black ${this.revealRadius}px, transparent ${this.revealRadius}px)`;
        if (trail.length === 0) {
          if (showCurrentCircle) {
            container.style.setProperty('--trail-mask', currentCircle);
          } else {
            container.style.setProperty('--trail-mask', '');
          }
          return;
        }
        if (trail.length === 1) {
          const point = trail[0];
          const radius = this.revealRadius * point.opacity;
          const trailCircle = `radial-gradient(circle ${radius}px at ${point.x}% ${point.y}%, black ${radius}px, transparent ${radius}px)`;
          const maskValue = showCurrentCircle ? `${currentCircle}, ${trailCircle}` : `${trailCircle}`;
          container.style.setProperty('--trail-mask', maskValue);
          return;
        }
        const gradients = showCurrentCircle ? [currentCircle] : [];
        for (let i = 0; i < trail.length; i++) {
          const point = trail[i];
          const radius = this.revealRadius * point.opacity;
          const overlapRadius = Math.max(radius, this.revealRadius * 1.1);
          gradients.push(`radial-gradient(circle ${overlapRadius}px at ${point.x}% ${point.y}%, black ${overlapRadius}px, transparent ${overlapRadius + 10}px)`);
          if (i > 0) {
            const prevPoint = trail[i - 1];
            const midX = (point.x + prevPoint.x) / 2;
            const midY = (point.y + prevPoint.y) / 2;
            const avgOpacity = (point.opacity + prevPoint.opacity) / 2;
            const connectRadius = (this.revealRadius * 1.1) * avgOpacity;
            gradients.push(`radial-gradient(circle ${connectRadius}px at ${midX}% ${midY}%, black ${connectRadius}px, transparent ${connectRadius + 5}px)`);
          }
        }
        // Combine all gradients - the overlapping will create a smooth continuous path
        const maskValue = gradients.join(', ');
        container.style.setProperty('--trail-mask', maskValue);
    }

    destroy() {
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
        }
        this.trailPoints.clear();
    }
}

// Initialize the effect when DOM is loaded
let blurRevealInstance = null;

function initBlurReveal() {
    if (blurRevealInstance) {
        blurRevealInstance.destroy();
    }
    blurRevealInstance = new BlurRevealEffect();
}

document.addEventListener('DOMContentLoaded', initBlurReveal);

// Also initialize if the script loads after DOM is ready
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initBlurReveal);
} else {
    initBlurReveal();
}

// function revealEffects() {
//   const radius = 15;
//   const fadeSpeed = 0.02;

//   document.querySelectorAll("img[data-reveal]").forEach(img => {
//     const blurSize = parseInt(img.dataset.blur) || 24;

//     const wrapper = document.createElement("div");
//     wrapper.className = "reveal-wrapper";
//     const canvas = document.createElement("canvas");
//     canvas.className = "reveal-canvas";
//     img.classList.add("reveal-img");

//     const parent = img.parentNode;
//     parent.insertBefore(wrapper, img);
//     wrapper.appendChild(canvas);
//     wrapper.appendChild(img);

//     const ctx = canvas.getContext("2d");
//     let trail = [];
//     let animationId = null;
//     let blurredCanvas, clearCanvas;
//     let isHovering = false;

//     function safeInit(retryCount = 0) {
//       const mediaDiv = wrapper.closest(".media") || wrapper;
//       const width = mediaDiv.offsetWidth;
//       const height = mediaDiv.offsetHeight;

//       // stop if image or layout not ready
//       if (
//         !width ||
//         !height ||
//         !img.naturalWidth ||
//         !img.naturalHeight ||
//         retryCount < 10 && (width === 0 || height === 0)
//       ) {
//         setTimeout(() => safeInit(retryCount + 1), 200);
//         return;
//       }

//       // set canvas sizes
//       canvas.width = width;
//       canvas.height = height;
//       canvas.style.width = width + "px";
//       canvas.style.height = height + "px";
//       wrapper.style.width = width + "px";
//       wrapper.style.height = height + "px";

//       blurredCanvas = document.createElement("canvas");
//       clearCanvas = document.createElement("canvas");
//       blurredCanvas.width = clearCanvas.width = width;
//       blurredCanvas.height = clearCanvas.height = height;

//       const blurCtx = blurredCanvas.getContext("2d");
//       const clearCtx = clearCanvas.getContext("2d");

//       // double check again before drawing
//       if (width === 0 || height === 0) return;

//       try {
//         blurCtx.filter = `blur(${blurSize}px)`;
//         blurCtx.drawImage(img, 0, 0, width, height);
//         clearCtx.drawImage(img, 0, 0, width, height);

//         ctx.clearRect(0, 0, width, height);
//         ctx.drawImage(blurredCanvas, 0, 0);
//       } catch (err) {
//         console.warn("Canvas draw skipped due to 0 size, retrying...");
//         setTimeout(() => safeInit(retryCount + 1), 200);
//       }
//     }

//     function draw() {
//       if (trail.length === 0) {
//         animationId = null;
//         return;
//       }

//       ctx.clearRect(0, 0, canvas.width, canvas.height);
//       ctx.drawImage(blurredCanvas, 0, 0);
//       ctx.save();
//       ctx.beginPath();

//       trail.forEach(p => {
//         ctx.globalAlpha = p.opacity;
//         ctx.arc(p.x, p.y, radius, 0, Math.PI * 2);
//       });

//       ctx.globalAlpha = 1;
//       ctx.clip();
//       ctx.drawImage(clearCanvas, 0, 0);
//       ctx.restore();

//       trail.forEach(p => (p.opacity -= fadeSpeed));
//       trail = trail.filter(p => p.opacity > 0);

//       animationId = requestAnimationFrame(draw);
//     }

//     function startAnimation() {
//       if (!animationId) animationId = requestAnimationFrame(draw);
//     }

//     function addPoint(x, y) {
//       const rect = canvas.getBoundingClientRect();
//       const scaleX = canvas.width / rect.width;
//       const scaleY = canvas.height / rect.height;
//       trail.push({ x: x * scaleX, y: y * scaleY, opacity: 1 });
//       startAnimation();
//     }

//     let lastTime = 0;
//     const throttle = 16;

//     function handleMove(e) {
//       if (!isHovering) return;
//       const now = Date.now();
//       if (now - lastTime < throttle) return;
//       lastTime = now;
//       e.preventDefault();

//       const rect = canvas.getBoundingClientRect();
//       const clientX = e.touches ? e.touches[0].clientX : e.clientX;
//       const clientY = e.touches ? e.touches[0].clientY : e.clientY;
//       addPoint(clientX - rect.left, clientY - rect.top);
//     }

//     function resetCanvas() {
//       trail = [];
//       ctx.clearRect(0, 0, canvas.width, canvas.height);
//       if (blurredCanvas) ctx.drawImage(blurredCanvas, 0, 0);
//     }

//     // Hover/touch listeners
//     canvas.addEventListener("mouseenter", () => (isHovering = true));
//     canvas.addEventListener("mouseleave", () => {
//       isHovering = false;
//       resetCanvas();
//     });
//     canvas.addEventListener("touchstart", () => (isHovering = true));
//     canvas.addEventListener("touchend", () => {
//       isHovering = false;
//       resetCanvas();
//     });

//     canvas.addEventListener("mousemove", handleMove);
//     canvas.addEventListener("touchmove", handleMove, { passive: false });

//     // Wait until image fully loaded before init
//     if (img.complete && img.naturalWidth > 0) {
//       safeInit();
//     } else {
//       img.addEventListener("load", () => safeInit());
//     }

//     // Reinitialize on resize
//     window.addEventListener("resize", () => {
//       cancelAnimationFrame(animationId);
//       safeInit();
//     });
//   });
// }

// revealEffects();




// product grid 

function initMobileProductToggle() {
  if (window.innerWidth < 992) {
    document.querySelectorAll(".snippet-product-grid").forEach(productItem => {
      const scent_cards = productItem.querySelectorAll(".grid-imagewrap .mobile-add-icon");
      const icons = productItem.querySelectorAll(".mobile-add-icon");
      const closeBtns = productItem.querySelectorAll(".close-popup");
      const multivars = productItem.querySelectorAll(".multi-variant-mobile");

      icons.forEach(icon => {
        icon.addEventListener("click", e => {
          e.preventDefault();
          productItem.classList.add("active-multi-product");
          // productItem.classList.add("active-product");
        });
      });

      closeBtns.forEach(closeBtn => {
        closeBtn.addEventListener("click", () => {
          productItem.classList.remove("active-product", "active-multi-product");
        });
      });

      multivars.forEach(multivar => {
        multivar.addEventListener("click", e => {
          e.preventDefault();
          productItem.classList.add("active-multi-product");
        });
      });

      scent_cards.forEach(scent_card => {
        scent_card.addEventListener("click", e => {
          e.preventDefault();
          e.stopPropagation();
          productItem.classList.add("active-product");
          // productItem.classList.add("active-multi-product");
          setTimeout(() => {
            productItem.classList.remove("active-product");
          }, 8000);
        });
      });
    });
  }
}


initMobileProductToggle();

// hide discount on load 

window.addEventListener("load", function() {
  const interval = setInterval(() => {
    const couponInput = document.querySelector("body.sticky-header .cart-sidebar .drawer-footer .df-wrap .docapp-with-shipping .docapp-coupon-input");
    if (couponInput) {
      couponInput.style.display = "none";
      clearInterval(interval); 
    }
  }, 100); 
});



// document.addEventListener('click', function (e) {
//   const btn = e.target.closest('.docapp-coupon-input--button');
//   if (!btn) return;

//   setTimeout(() => {
//     const removeBean = document.querySelector('.docapp-coupon-input--bean-container--bean-remove');
//     const totalPriceEl = document.querySelector('.cart-total .final-total .cart-total-price');

//     if (removeBean && totalPriceEl) {
//       totalPriceEl.textContent = 'Updated total';   
//     }
//   }, 300); 
// });



document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.grid-size-variants').forEach(list => {
    let items = Array.from(list.querySelectorAll('.variant-grid'));
    items.sort((a, b) => {
      let aPrice = parseFloat(a.getAttribute('data-price')) || 0;
      let bPrice = parseFloat(b.getAttribute('data-price')) || 0;
      return aPrice - bPrice;
    });
    items.forEach(item => list.appendChild(item));
  });
});